import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';

import { showEditPageItemNameEditorErrors } from '../../../actions/editPageItemNameEditor';
import { selectEditPageItemNameEditorValue } from '../../../selectors/editPageItemNameEditor/editPageItemNameEditor';
import { ValidationErrorData } from '../../../typings/common';
import { State } from '../../../typings/state';
import { VideoCreatorVideoResource } from '../../api/typings';
import { VideoCreatorResourceType } from '../../VideoCreatorHelper/typings';
import { showVideoCreatorParamsErrors } from '../actions';

import * as keyset from './helpers.i18n';

const i18n = i18nFactory(keyset);

export const getVideoNameEditorValidationResult = (id: string, state: State): ValidationErrorData[] => {
    const editorData = selectEditPageItemNameEditorValue(state.editPageItemNameEditor, id);

    if (!editorData.value && editorData.isVisible) {
        return [
            {
                path: `name`,
                code: 'required',
                text: i18n('validation-empty-name')
            }
        ];
    }

    return [];
};

export const getVideoResourceEditorValidationResult = (state: State): ValidationErrorData[] => {
    const { videoResources } = state.videoCreatorEdit;

    return Object.keys(videoResources).reduce((acc: ValidationErrorData[], key) => {
        const resource: VideoCreatorVideoResource = videoResources[key];

        if (resource.resourceType === VideoCreatorResourceType.text && !resource.text) {
            acc.push({
                path: key,
                code: 'required',
                text: i18n('validation-empty-text')
            });
        }

        return acc;
    }, []);
};

export const getVideoCreatorSaveDataValidationResult = (
    id: string,
    state: State
): { valid: boolean; showErrorsActions: Action[] } => {
    let showErrorsActions: Action[] = [];
    let valid: boolean = true;

    const nameEditorErrors = getVideoNameEditorValidationResult(id, state);

    if (nameEditorErrors.length > 0) {
        valid = false;
        showErrorsActions = showErrorsActions.concat(showEditPageItemNameEditorErrors(id, nameEditorErrors));
    }

    const resourceEditorErrors = getVideoResourceEditorValidationResult(state);

    if (resourceEditorErrors.length > 0) {
        valid = false;
        showErrorsActions = showErrorsActions.concat(showVideoCreatorParamsErrors(resourceEditorErrors));
    }

    return {
        valid,
        showErrorsActions
    };
};
